import type { FaireProductEntity } from "../../entity_types/product";

export const p_4tspp7j534: FaireProductEntity = {
  token: "p_4tspp7j534",
  type: "product",
  name: "HALLOWEEN GHOST PUMPKIN BUTTON CARDIGAN",
  brandToken: "b_1taybicqc4",
  brandName: "BiBi",
  imageUrl:
    "https://cdn.faire.com/fastly/231a354102fa85bd08cd65d8843ab7989c4892398d1ac1e7149650e75796bbe4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ef04654be36b7b763109f0dc5a90fa5b99f356b31bf9ed5c9d128c7cc862c82e.jpeg",
    "https://cdn.faire.com/fastly/9a2ab84413d2cedbe46bfd066ed1a9e97a9503f7d2b399d5055bd5ba3c4f6389.jpeg",
    "https://cdn.faire.com/fastly/ef218ac9e98181f76811ba243962b018f7b99338211d1c2050f1d913c2635cdc.jpeg",
    "https://cdn.faire.com/fastly/0de73c4b72c6dd362363bab265bfca897f7bd5ca731adcc2b3c0382a0cb01d8a.jpeg",
    "https://cdn.faire.com/fastly/0a8864ad4d2219d9573f598856762c814fd3b43b7a610f1e7f8579596bb2f76b.jpeg",
    "https://cdn.faire.com/fastly/2ea5708fd09ea6356c15e1325f77f934fc0941876029284db7d96a1f976b84dc.jpeg",
    "https://cdn.faire.com/fastly/bf6430fd7a20064a221dfb66850bbe566077835b3470f99b8a03ec04468e0296.jpeg",
    "https://cdn.faire.com/fastly/15f09af081670085f9d8f4e6d00a16fba889fdb02d02c5727a3ba697c6aa862b.jpeg",
    "https://cdn.faire.com/fastly/1a186a6f3a72997e1daf4b6e20c695423a0c3293654a67ad07e791e9db1298ee.jpeg",
    "https://cdn.faire.com/fastly/55fc6d441bff777993a65921efb636b2b15c1044ef4d13c899eda2668a942294.jpeg",
    "https://cdn.faire.com/fastly/e764bcf9b018bf7e38a5154844e4b6012fbfb7be4a93d6bc2b9bfc68f48680cd.jpeg",
    "https://cdn.faire.com/fastly/2f02b76f1a951bab3e1e86006ef9faea660bb37a8f5561fb6a8f1b8e4ad6675e.jpeg",
    "https://cdn.faire.com/fastly/ab3cdb67be5963a4bd6dfc736e20b32e8b1776851e5603e39d14490a744433b7.jpeg",
    "https://cdn.faire.com/fastly/70652d3affe1224235edd9054523094395f0f7a3f9f3a7e80df7c0ea95e9971f.jpeg",
    "https://cdn.faire.com/fastly/15bab3199bb0e8f8c326dab54fd175f47944674e51746e0e7c97728d99161683.jpeg",
    "https://cdn.faire.com/fastly/55073165eb9a3841cf3fdeb428380612ffcbfe6c0ba4eb41288b2eed9d10a369.jpeg",
    "https://cdn.faire.com/fastly/09ab34254c2b83aa05362881d8b871205a617ea7009a8266555e7b5ce173eb10.jpeg",
    "https://cdn.faire.com/fastly/404a9fa8bf65cdf44f2577dba62712277ca488ca56e1ec5f86eb08cc523f1f69.jpeg",
  ],
  priceDollars: 167.6,
  description:
    "This cozy Halloween cardigan is an easy seasonal favorite for women who want a festive look without wearing a costume. Designed with cute ghost, pumpkin, and bat motifs, it features a soft fuzzy knit, button-front closure, relaxed fit, and full-length coverage. A great fall piece for boutiques, gift shops, and missy customers.",
  tags: [],
  msrpDollars: 335.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:34.339Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
